<template>

</template>

<script>
export default {
    data() {
        return {
            list: [],
            registrationurl: "",
            query: {
                page: 1,
                limit: 10
            }
        };
    },
    methods: {

    },

};
</script>
